module.exports = __webpack_public_path__ + "img/discord-3.26c73673.svg";